import { Permission } from "shared/types/permission.enum";
import { to } from "routing/to";
import { NavigationBarRouteConfig } from "./navigation.types";

export const navigationBarConfig: NavigationBarRouteConfig[] = [
  {
    path: to.dashboard,
    translationKey: "navigation.routes.dashboard"
  },
  {
    translationKey: "navigation.routes.features.name",
    children: [
      {
        path: to.activationPopups,
        translationKey: "navigation.routes.features.activation"
      },
      {
        path: to.abandonmentMails,
        translationKey: "navigation.routes.features.mails"
      },
      {
        path: to.newsletterForms,
        translationKey: "navigation.routes.features.optin"
      },
      {
        path: to.browseAbandonment,
        translationKey: "navigation.routes.features.browseAbandonment",

        requiredPermission: Permission.USER
      },
      {
        path: to.comeBackMailing,
        translationKey: "navigation.routes.features.comeBackMailing",

        requiredPermission: Permission.USER
      }
    ]
  },
  {
    path: to.integrations,
    translationKey: "navigation.routes.integrations"
  },
  {
    path: to.algorithm,
    translationKey: "navigation.routes.algorithm"
  },
  {
    translationKey: "navigation.routes.settings.name",
    requiredPermission: Permission.SALES,
    children: [
      {
        path: to.shopConfiguration,
        translationKey: "navigation.routes.settings.shop"
      },
      {
        path: to.tracking,
        translationKey: "navigation.routes.settings.tracking"
      },
      {
        path: to.triggerMailsPayment,
        translationKey: "navigation.routes.settings.payment",

        requiredPermission: Permission.SALES
      }
    ]
  },
  {
    translationKey: "navigation.routes.admin.name",
    requiredPermission: Permission.SALES,
    children: [
      {
        path: to.reportedRegains,
        translationKey: "navigation.routes.admin.reportedRegains"
      },
      {
        path: to.reportedSubscriptions,
        translationKey: "navigation.routes.admin.reportedSubscriptions"
      },
      {
        path: to.storeAdministration,
        translationKey: "navigation.routes.admin.shopAdministration"
      },
      {
        path: to.userAdministration,
        translationKey: "navigation.routes.admin.userAdministration"
      },
      {
        path: to.featureToggles,
        translationKey: "navigation.routes.admin.featureToggles",
        requiredPermission: Permission.ADMIN
      },
      {
        path: to.activationManager,
        translationKey: "navigation.routes.admin.activationManager",
        requiredPermission: Permission.ADMIN
      },
      {
        path: to.cmsEditor,
        translationKey: "navigation.routes.admin.templateTextDesigner",
        requiredPermission: Permission.ADMIN
      },
      {
        path: to.templateEditor,
        translationKey: "navigation.routes.admin.templateEditor",
        requiredPermission: Permission.ADMIN
      },
      {
        path: to.mailTemplates,
        translationKey: "navigation.routes.admin.mailTemplates",
        requiredPermission: Permission.ADMIN
      },
      {
        path: to.abTests,
        translationKey: "navigation.routes.admin.aBTests",
        requiredPermission: Permission.ADMIN
      },
      {
        path: to.provisionDashboard,
        translationKey: "navigation.routes.admin.provisionDashboard"
      },
      {
        path: to.fuzzyEditor,
        translationKey: "navigation.routes.admin.fuzzyEditor",
        requiredPermission: Permission.ADMIN
      },
      {
        path: to.testPricingForm,
        translationKey: "navigation.routes.admin.testPricingForm",
        requiredPermission: Permission.ADMIN
      },
      {
        path: to.triggerMailsBlock,
        translationKey: "navigation.routes.admin.triggerMailsBlock",
        requiredPermission: Permission.SALES
      }
    ]
  },
  {
    translationKey: "navigation.routes.analysis.name",
    requiredPermission: Permission.SALES,
    children: [
      {
        path: to.mailCancellationDrops,
        translationKey: "navigation.routes.analysis.mailCancellationDrops"
      },
      {
        path: to.activationCancellationDrops,
        translationKey: "navigation.routes.analysis.activationCancellationDrops"
      },
      {
        path: to.mailRegainDrops,
        translationKey: "navigation.routes.analysis.mailRegainDrops"
      },
      {
        path: to.activationRegainDrops,
        translationKey: "navigation.routes.analysis.activationRegainDrops"
      },
      {
        path: to.sessionDrops,
        translationKey: "navigation.routes.analysis.sessionDrops"
      },
      {
        path: to.orderDrops,
        translationKey: "navigation.routes.analysis.orderDrops"
      },
      {
        path: to.zeroScv,
        translationKey: "navigation.routes.analysis.zeroSCV"
      },
      {
        path: to.invoiceDrops,
        translationKey: "navigation.routes.analysis.invoiceDrops"
      },
      {
        path: to.invoices,
        translationKey: "navigation.routes.analysis.invoices"
      }
    ]
  }
];
